var exports = {
  "k": "container__mID7Qr",
};

module.exports = exports;
